import { useAtomValue } from 'jotai';

import { currentAccountRoleState } from '../store';

import type { AccountRolePermissions } from '@rewardopl/types';
export default function useAccountPermission(permission: keyof AccountRolePermissions): boolean {
  const currentAccountRole = useAtomValue(currentAccountRoleState);

  const accountRolePermissions = currentAccountRole.permissions;

  return accountRolePermissions[permission] ?? false;
}
